export const temporaryButtonErrorCatcher =
  <T>(fn?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => T | Promise<T>) =>
  async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    try {
      if (!fn) return;
      const result = await fn(e);
      return result;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
